import { NOTIFICATION_TYPES } from '../../../constants';
import { sortByTimestampDesc } from '../../../../../../common/utils/dateTimeUtils';
import type { ToBeReviewedItem } from './buildToBeReviewed';

export const isToBeReviewedNotification = (
  item: { type?: string } | null | undefined
): item is ToBeReviewedItem => item?.type === NOTIFICATION_TYPES.TO_BE_REVIEWED_PICKUP;

/**
 * One summary card for active To Be Reviewed pickups (All and Pickups chips).
 * Uses the most recent details and moreToReviewCount for the remaining pickups.
 */
export const aggregateToBeReviewedSummary = (
  items: ToBeReviewedItem[] = []
): ToBeReviewedItem[] => {
  if (!items.length) {
    return [];
  }

  const sorted = sortByTimestampDesc(items, (item) => item.timestamp);
  const [newest, ...rest] = sorted;

  return [
    {
      ...newest,
      moreToReviewCount: rest.length,
      relatedPickupIds: sorted.map((item) => item.pickupId),
    },
  ];
};
